import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useMemo } from 'react';
import { AnalyticsHandlerRegistrant } from '../analytics';
import { transformObjectActionEvent } from './event-transformation';
import { jsx as _jsx } from "react/jsx-runtime";
export const DataLayerAnalyticsHandler = _ref => {
  let {
    dataLayerName = 'dataLayer'
  } = _ref;
  const handler = useMemo(() => ({
    async trackEvent(event) {
      if (window[dataLayerName] === undefined) {
        ;
        window[dataLayerName] = [];
      }
      const dataLayer = window[dataLayerName];
      if ('type' in event) {
        switch (event.type) {
          case 'test':
            return;
          case 'legacy':
            {
              const data = event.data;
              if ('ecommerce' in data && data.ecommerce) {
                dataLayer.push({
                  ecommerce: null
                });
              }
              dataLayer.push(event.data);
            }
            break;
          default:
            {
              const _exhaustive = event;
              break;
            }
        }
      } else {
        const items = transformObjectActionEvent(event);
        if (Array.isArray(items)) {
          dataLayer.push(...items);
        } else {
          dataLayer.push(items);
        }
      }
    }
  }), [dataLayerName]);
  return /*#__PURE__*/_jsx(AnalyticsHandlerRegistrant, _objectSpread(_objectSpread({}, handler), {}, {
    "data-id": "analytics-datalayer_analytics-handler_DataLayerAnalyticsHandler_AnalyticsHandlerRegistrant"
  }));
};